import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectDealerSelected } from 'app/pages/Header/selectors';
import { isV2Dealership as checkIsV2Dealership } from 'app/utils/dealerVersion';
import { hasDealerContext } from 'utils/hasDealerContext';

export const useConfigurePage = () => {
  const history = useHistory();
  const selectedDealer = useSelector(selectDealerSelected);
  const hasSelectedDealer = hasDealerContext(selectedDealer);
  const isV2Dealership = useMemo(
    () => checkIsV2Dealership(selectedDealer),
    [selectedDealer],
  );

  const goToContent = useCallback(() => {
    history.push('/content', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Content Management', isActive: true },
      ],
    });
  }, [history]);

  const goToCalendarConfiguration = useCallback(() => {
    history.push('/configure-calendar', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Channel settings', isActive: true },
      ],
    });
  }, [history]);

  const goToSegmentsConfiguration = useCallback(() => {
    history.push('/configure-segments', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Dealer segment settings', isActive: true },
      ],
    });
  }, [history]);

  const goToTemplateValuePreferences = useCallback(() => {
    history.push('/configure-template-value', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Template Value Preferences', isActive: true },
      ],
    });
  }, [history]);

  const goToTemplateMessageTypeFocus = useCallback(() => {
    history.push('/configure-template-message-type', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Segment Message Type Focus', isActive: true },
      ],
    });
  }, [history]);

  const goToStaticContentValueMessages = useCallback(() => {
    history.push('/configure-static-content', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Static Content - Value Messages', isActive: true },
      ],
    });
  }, [history]);

  const goToNurturingJourneySettings = useCallback(() => {
    history.push('/configure-nurturing-journey', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Nurturing Journey Settings', isActive: true },
      ],
    });
  }, [history]);

  const goToCdpSettings = useCallback(() => {
    history.push('/configure-cdp-settings', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'CDP Settings', isActive: true },
      ],
    });
  }, [history]);

  const goToNurturingPlanGenerator = useCallback(() => {
    history.push('/nurturing-plan-generator', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Nurturing Plan Generator', isActive: true },
      ],
    });
  }, [history]);

  const goToLaunchSettings = useCallback(() => {
    history.push('/configure-launch-settings', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Launch settings', isActive: true },
      ],
    });
  }, [history]);

  const goToInventoryFeedSettings = useCallback(() => {
    history.push('/configure-inventory-feed-settings', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Inventory Feed Settings', isActive: true },
      ],
    });
  }, [history]);

  return {
    hasSelectedDealer,
    isV2Dealership,
    goToContent,
    goToCalendarConfiguration,
    goToSegmentsConfiguration,
    goToTemplateValuePreferences,
    goToTemplateMessageTypeFocus,
    goToStaticContentValueMessages,
    goToNurturingJourneySettings,
    goToCdpSettings,
    goToNurturingPlanGenerator,
    goToLaunchSettings,
    goToInventoryFeedSettings,
  };
};
